import { useEffect } from "react";
import { Buttons, MainContainer } from "components/common";
import {
  BottomContainer,
  CardContainer,
  HeaderIcons,
  HeaderText,
  MainTrendingNFTs,
  TrendingNFTsHeading,
  BottomHeader,
  TextWrapper,
  BottomText,
  BtnContainer,
  Question,
  CardBtn,
} from "./element";
import { BsArrowRight } from "react-icons/bs";
import { useState } from "react";
import { AddFavouriteHook, RemoveFavouriteHook, TrendingNftsHook } from "hooks";
import CollectionCard from "components/collectionAll/collectionCard";
import { useAppSelector } from "store/store";
import * as C from "components/common";
import { sliderSettings } from "../data/carouselData";
import { Swiper, SwiperSlide } from "swiper/react";
import { FreeMode, Navigation } from "swiper";

function TrendingNFTs() {
  const [hover, setHover] = useState(false);
  const [cardHover, setCardHover] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(undefined);

  const { account } = useAppSelector((state) => state.web3Connect);

  const { data, error, loading, refetch } = TrendingNftsHook();
  const { addFav, data: addFavData } = AddFavouriteHook();
  const { removeFav, data: removeFavData } = RemoveFavouriteHook();

  const handleMouseOver = () => {
    setHover(true);
  };

  const handleMouseOut = () => {
    setHover(false);
  };

  //useEffect
  useEffect(() => {
    (addFavData || removeFavData) && refetch();
  }, [addFavData, removeFavData]);

  return (
    <MainTrendingNFTs>
      {data.length > 0 && (
        <MainContainer>
          <TrendingNFTsHeading
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ delay: 0.15, duration: 1 }}
          >
            Trending NFTs
          </TrendingNFTsHeading>

          <CardContainer
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ delay: 0.15, duration: 1 }}
          >
            <Swiper
              spaceBetween={0}
              freeMode={true}
              modules={[FreeMode]}
              breakpoints={{
                100: {
                  slidesPerView: 1,
                },
                768: {
                  slidesPerView: 1.9,
                },
                1024: {
                  slidesPerView: 4.2,
                },
              }}
            >
              {loading
                ? "Loading Trending nfts..."
                : data?.map((item, index) => {
                    const fav = item.favourites.find(
                      (x) => x.user_address === account?.toLocaleLowerCase()
                    );
                    const data = {
                      changeFav: fav ? removeFav : addFav,
                      favId: fav?.id,
                      metadata_id: item?.meta_data.id,
                      metadata: {
                        id: item?.id,
                        price: item?.signed_order.erc20TokenAmount,
                        network: item.network,
                        erc20Token: item?.signed_order.erc20Token,
                        sold: item?.sold,
                        token_id: item?.meta_data?.token_id,
                        name:
                          item?.nft?.name ||
                          item?.meta_data?.asset_contract.name,
                      },
                      buttonTxt: "Details",
                      image:
                        item?.nft?.image || item?.meta_data?.image_preview_url,
                      nft_id: item?.meta_data ? item.meta_data.id : item.nft_id,
                    };
                    return (
                      <div>
                        <SwiperSlide>
                          <CollectionCard
                            key={`trending-${index}`}
                            data={data}
                          />
                        </SwiperSlide>
                      </div>
                    );
                  })}
            </Swiper>
          </CardContainer>
        </MainContainer>
      )}

      <BottomContainer
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ delay: 0.15, duration: 1 }}
      >
        <MainContainer>
          <TextWrapper>
            <BottomHeader>Lorem ipsum dolor sit amet</BottomHeader>
            <BottomText>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sit
              facilisis nam rhoncus quisque. Urna placerat nunc eget id ornare
              tincidunt vulputate. Metus, faucibus fermentum, vestibulum, lorem.{" "}
            </BottomText>
          </TextWrapper>
          <BtnContainer>
            <Buttons
              explore
              onMouseOver={handleMouseOver}
              onMouseOut={handleMouseOut}
            >
              Start Earning {hover && <BsArrowRight />}
            </Buttons>
            <Question />
          </BtnContainer>
        </MainContainer>
      </BottomContainer>
    </MainTrendingNFTs>
  );
}

export default TrendingNFTs;
